//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ValidationObserver, extend } from 'vee-validate';
import { messages } from 'vee-validate/dist/locale/en.json';
import { required, email, max } from 'vee-validate/dist/rules';
const rules = { required, email, max };
for (const [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation,
    message: messages[rule],
  });
}

export default {
  name: 'BaseContactForm',
  components: {
    ValidationObserver,
  },

  // Injected from the Vuetify Themeable mixin
  inject: ['theme'],

  props: {
    subtitle: { type: String, default: null },
    title: {
      type: String,
      default: 'EMAIL US YOUR MESSAGE',
    },
  },
  data: () => ({
    action: 'https://formspree.io/f/mjvpyzne',
    form: {
      name: null,
      _replyto: null,
      _subject: null,
      message: '',
    },
    submitting: null,
    error: null,
    success: null,
  }),
  methods: {
    async submit() {
      this.submitting = true;
      try {
        await this.$axios.$post(this.action, this.form);
        this.error = false;
        this.success = true;
        this.form = {};
        requestAnimationFrame(() => {
          this.$refs.obs.reset();
        });
      } catch (error) {
        this.error = true;
        this.$sentry.captureException(error);
      } finally {
        this.submitting = false;
      }
    },
  },
};
